import React, { useEffect } from "react";
import "../../../assets/css/BlockRackTable/blockRackTable.css";
import useTableSort from "../../../hooks/useTableSort";
import NoResult from "../../Reusables/DataTable/NoResult";
import { SortableHeader } from "../../Reusables/DataTable/SortableHeader";
import { TableVirtuoso } from "react-virtuoso";

const NonLGVInventoryTable = ({
  data,
  updateNonLgvExportData,
  columns,
  isTableSearchFiltersEnabled
}) => {

  const { requestSort, sortConfig, sortedData } = useTableSort(data);

  useEffect(() => {
    updateNonLgvExportData(sortedData);
  }, [sortedData]);

  if (!data) {
    return (
      <div className="table-loader">
        <h4>Loading...</h4>
        <div className="table-spinner"></div>
      </div>
    );
  }
  return (
    <>
      <TableVirtuoso
        style={{ height: "100%" }}
        data={sortedData}
        fixedHeaderContent={() => (
          <tr>
            {columns.map(({ label, key,enableSort }, index) => (
              <SortableHeader
                key={index}
                field={key}
                label={label}
                sortConfig={sortConfig}
                requestSort={requestSort}
                enableSort={enableSort}
              />
            ))}
          </tr>
        )}
        itemContent={(index, row) => (
          <>
            {columns.map(({ key }) =>
              !isTableSearchFiltersEnabled && key === "location" ? null : (
                <td className="block-table-data-block-rack" key={key}>
                  {row[key]}
                </td>
              )
            )}
          </>
        )}
        components={{
          EmptyPlaceholder: () => <NoResult colSpan={columns.length} />,
          Table: (props) => (
            <table id="block-location-table-block-rack-hof" {...props} />
          )
        }}
      />
    </>
  );
};
export default NonLGVInventoryTable;
